import { render, staticRenderFns } from "./TrademarkWipoXmlUploadForm.vue?vue&type=template&id=f4729552&"
import script from "./TrademarkWipoXmlUploadForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkWipoXmlUploadForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkWipoXmlUploadForm.vue?vue&type=style&index=0&id=f4729552&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports